import React from "react";
// import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import XLSX from 'xlsx';
import { saveAs } from "file-saver";
import orderBy from 'lodash.orderby';

import Layout from "src/components/layout";
import Icons from "src/components/icons";
import SEO from "src/components/seo";
import Hero from "src/components/hero";
import Breadcrumb from "src/components/breadcrumb";

import logo2 from "src/images/logo-polb-update-final-alternate-2.png"
import bcLogoPrint from "src/images/blue-cargo-print.png";

class BlueCargo extends React.Component {
  constructor(props) {
    super(props);
    this.expandRow = this.expandRow.bind(this);
    this.printTable = this.printTable.bind(this);
    this.pdfTable = this.pdfTable.bind(this);
    this.excelTable = this.excelTable.bind(this);
    this.orderArray = this.orderArray.bind(this);
    this.tableConversion = this.tableConversion.bind(this);
  }

  state = {
    tableData: []
  }

  componentDidMount() {
    let requestHeaders = {
      headers: {
        Authorization: "tHQr89iT5XFpVnD-sGaPbtsj3ZeCSOh5xuFqkvCD"
      }
    }
    fetch("https://api.bluecargo.io/core/api/gate_schedules/", requestHeaders)
      .then(response => response.json())
      .then(json => {
        if (json.length > 0) {
          this.orderArray(json);
        } else {
          console.log("Data did not load");
        }
      })
  }

  expandRow(e) {
    let element = e.currentTarget;
    let elementText = element.children[2].textContent;
    let dataButtons = document.querySelectorAll(".data-button");

    for (let index = 0; index < dataButtons.length; index++) {
      if (dataButtons[index].classList.contains("active-list") || dataButtons[index].children[2].textContent !== elementText) {
        dataButtons[index].classList.remove("active-list");
      } else {
        dataButtons[index].classList.add("active-list");
      }
    }
  }

  printTable() {
    let table = document.getElementById("bc-table-print");

    if (typeof window !== undefined) {
      let newWindow = window.open();
      newWindow.document.write(table.outerHTML);
      newWindow.print();
      newWindow.close();
    }
  }

  pdfTable() {
    if (typeof window !== undefined) {
      const jsPDF = require("jspdf");
      const doc = new jsPDF.jsPDF('l');

      doc.text(125, 11, "Gate Schedules");

      doc.setFontSize(12);

      doc.text(215, 11, "Data powered by BlueCargo");

      doc.addImage(logo2, "PNG", 11, 2, 60, 15);
      doc.addImage(bcLogoPrint, "PNG", 270, 4, 15, 10);

      const res = doc.autoTableHtmlToJson(document.getElementById('bc-table-pdf-1'));
      doc.autoTable(res.columns, res.data, {
        startY: 20,
        columnStyles: { 0: { cellWidth: 20 } },
        headerStyles: { fillColor: [226, 226, 226] },
        didParseCell: function (res) {
          res.cell.styles.textColor = [22, 20, 64];

          if (res.cell.text.indexOf('Closed') > -1) {
            res.cell.styles.fillColor = [255, 165, 0];
          }
        }
      });

      const res2 = doc.autoTableHtmlToJson(document.getElementById('bc-table-pdf-2'));
      doc.autoTable(res2.columns, res2.data, {
        startY: doc.lastAutoTable.finalY + 10,
        columnStyles: { 0: { cellWidth: 20 } },
        headerStyles: { fillColor: [226, 226, 226] },
        didParseCell: function (res2) {
          res2.cell.styles.textColor = [22, 20, 64];

          if (res2.cell.text.indexOf('Closed') > -1) {
            res2.cell.styles.fillColor = [255, 165, 0];
          }
        },
      });

      const res3 = doc.autoTableHtmlToJson(document.getElementById('bc-table-pdf-3'));
      doc.autoTable(res3.columns, res3.data, {
        startY: doc.lastAutoTable.finalY + 10,
        columnStyles: { 0: { cellWidth: 20 } },
        headerStyles: { fillColor: [226, 226, 226] },
        didParseCell: function (res3) {
          res3.cell.styles.textColor = [22, 20, 64];

          if (res3.cell.text.indexOf('Closed') > -1) {
            res3.cell.styles.fillColor = [255, 165, 0];
          }
        },
      });

      doc.save("gate-hours.pdf");
    }
  }

  excelTable() {
    let wb = XLSX.utils.table_to_book(document.getElementById('bc-table-document'), { sheet: "Gate Hours" });

    let wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "binary" });

    saveAs(new Blob([this.tableConversion(wbout)], { type: "application/octet-stream" }), 'gate-hours.xlsx');
  }

  tableConversion(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  orderArray(data) {
    let modifiedData = data;

    for (let index = 0; index < modifiedData.length; index++) {
      if (modifiedData[index].terminal.name === "SSA Pier A") {
        modifiedData[index]["order"] = 1;
        modifiedData[index].terminal.name = "Pier A SSA";
      } else if (modifiedData[index].terminal.name === "SSA Matson") {
        modifiedData[index]["order"] = 2;
        modifiedData[index].terminal.name = "Pier C SSA Matson";
      } else if (modifiedData[index].terminal.name === "LBCT") {
        modifiedData[index]["order"] = 3;
        modifiedData[index].terminal.name = "Pier E LBCT";
      } else if (modifiedData[index].terminal.name === "ITS") {
        modifiedData[index]["order"] = 4;
        modifiedData[index].terminal.name = "Pier G ITS";
      } else if (modifiedData[index].terminal.name === "SSA PCT") {
        modifiedData[index]["order"] = 5;
        modifiedData[index].terminal.name = "Pier J SSA PCT";
      } else if (modifiedData[index].terminal.name === "TTI") {
        modifiedData[index]["order"] = 6;
        modifiedData[index].terminal.name = "Pier T TTI";
      }
    }

    let orderedArray = orderBy(modifiedData.map(item => item), ['order']);

    this.setState({ tableData: orderedArray });
  }

  render() {
    const tableData = this.state.tableData;

    const printTableStyles = {
      "borderCollapse": "collapse",
      "clear": "both",
      "width": "100%",
      "display": "inline-block",
      "color": "#161440"
    }

    const printTableStylesTwo = {
      "borderCollapse": "collapse",
      "clear": "both",
      "width": "100%",
      "display": "block",
      "color": "#161440",
      // "page-break-before": "always"
    }

    const printHeaderStyles = {
      "backgroundColor": "#ececec",
      "fontFamily": "'DIN Next LT W01 Heavy', 'DIN Next LT Pro Heavy', 'Helvetica Neue', 'Helvetica', 'sans-serif'",
      "fontSize": "1rem",
      "fontWeight": "normal",
      "textAlign": "left",
      "padding": "10px",
      "margin": "0px 10px",
      "color": "#161440"
    }

    const printHeaderTextStyles = {
      "marginTop": "5px",
      "marginBottom": "5px",
      "color": "#161440"
    }

    const printBodyStyles = {
      "fontFamily": "'DIN Next LT W01 Regular', 'DIN Next LT Pro', 'Helvetica Neue', 'Helvetica', 'sans-serif'",
      "padding": "10px",
      "margin": "0px 10px",
      "color": "#161440"
    }

    const printBodyStylesTwo = {
      "fontFamily": "'DIN Next LT W01 Regular', 'DIN Next LT Pro', 'Helvetica Neue', 'Helvetica', 'sans-serif'",
      "padding": "10px",
      "margin": "0px 10px",
      "color": "#161440",
      "backgroundColor": "#ffa500"
    }

    const printBodyTextBold = {
      "fontFamily": "'DIN Next LT W01 Regular', 'DIN Next LT Pro', 'Helvetica Neue', 'Helvetica', 'sans-serif'",
      "fontWeight": "bold",
      "padding": "10px",
      "margin": "0px 10px",
      "color": "#161440"
    }

    const headerContainer = {
      "display": "flex",
      "justifyContent": "space-between",
      "alignItems": "center"
    }

    const bcTextContainer = {
      "display": "inline-block"
    }

    const bcText = {
      "display": "inline-block",
      "fontStyle": "italic",
      "fontWeight": "bold"
    }

    const bcLogo = {
      "width": "75px",
      "height": "50px",
      "transform": "translateY(15px)"
    }

    return (
      <React.Fragment>
        <Icons />

        <Layout hasHero={false}>
          <SEO title="Gate Hours" description="View this week's port gate hours" />

          <div className="bc-break-div"></div>

          <Breadcrumb categories="Port Info" pageTitle="Gate Hours" socialShare />

          <div className="bc-header-container gutter">
            <h2 className="bc-title">Gate Hours</h2>
            <a href="https://www.bluecargo.io/" target="_blank" className="bc-text-container">
              <p className="intro bc-text">Data powered by BlueCargo</p>
              <svg className="icon icon--blue-cargo-logo"><use xlinkHref="#blue-cargo-logo" /></svg>
            </a>
          </div>

          {/* <h2 className="bc-week-title gutter">This Week</h2> */}

          {/* <div className="bc-table-container gutter">
            <div className="shadow-div"></div>
            <table id="bc-table" className="bc-table files">
              <thead class="bc-table__header"><tr><th class="header-data col-1"><p>Terminal</p></th><th class="header-data"><p>05/29/23</p><p>Shift 1</p></th><th class="header-data"><p>05/29/23</p><p>Shift 2</p></th><th class="header-data"><p>05/29/23</p><p>Shift 3</p></th><th class="header-data"><p>05/30/23</p><p>Shift 1</p></th><th class="header-data"><p>05/30/23</p><p>Shift 2</p></th><th class="header-data"><p>05/30/23</p><p>Shift 3</p></th><th class="header-data"><p>05/31/23</p><p>Shift 1</p></th><th class="header-data"><p>05/31/23</p><p>Shift 2</p></th><th class="header-data"><p>05/31/23</p><p>Shift 3</p></th><th class="header-data"><p>06/01/23</p><p>Shift 1</p></th><th class="header-data"><p>06/01/23</p><p>Shift 2</p></th><th class="header-data"><p>06/01/23</p><p>Shift 3</p></th><th class="header-data"><p>06/02/23</p><p>Shift 1</p></th><th class="header-data"><p>06/02/23</p><p>Shift 2</p></th><th class="header-data"><p>06/02/23</p><p>Shift 3</p></th><th class="header-data"><p>06/03/23</p><p>Shift 1</p></th><th class="header-data"><p>06/03/23</p><p>Shift 2</p></th><th class="header-data"><p>06/03/23</p><p>Shift 3</p></th><th class="header-data"><p>06/04/23</p><p>Shift 1</p></th><th class="header-data"><p>06/04/23</p><p>Shift 2</p></th><th class="header-data"><p>06/04/23</p><p>Shift 3</p></th><th class="header-data"><p>06/05/23</p><p>Shift 1</p></th><th class="header-data"><p>06/05/23</p><p>Shift 2</p></th><th class="header-data"><p>06/05/23</p><p>Shift 3</p></th><th class="header-data"><p>06/06/23</p><p>Shift 1</p></th><th class="header-data"><p>06/06/23</p><p>Shift 2</p></th><th class="header-data"><p>06/06/23</p><p>Shift 3</p></th><th class="header-data"><p>06/07/23</p><p>Shift 1</p></th><th class="header-data"><p>06/07/23</p><p>Shift 2</p></th><th class="header-data"><p>06/07/23</p><p>Shift 3</p></th><th class="header-data"><p>06/08/23</p><p>Shift 1</p></th><th class="header-data"><p>06/08/23</p><p>Shift 2</p></th><th class="header-data"><p>06/08/23</p><p>Shift 3</p></th><th class="header-data"><p>06/09/23</p><p>Shift 1</p></th><th class="header-data"><p>06/09/23</p><p>Shift 2</p></th><th class="header-data"><p>06/09/23</p><p>Shift 3</p></th><th class="header-data"><p>06/10/23</p><p>Shift 1</p></th><th class="header-data"><p>06/10/23</p><p>Shift 2</p></th><th class="header-data"><p>06/10/23</p><p>Shift 3</p></th><th class="header-data"><p>06/11/23</p><p>Shift 1</p></th><th class="header-data"><p>06/11/23</p><p>Shift 2</p></th><th class="header-data"><p>06/11/23</p><p>Shift 3</p></th></tr></thead>
              <tbody class="bc-table__body"><tr><td class="body-data col-1"><p>Pier A SSA</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Limited</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td></tr><tr><td class="body-data col-1 grey"><p>Pier C SSA Matson</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td></tr><tr><td class="body-data col-1"><p>Pier E LBCT</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td></tr><tr><td class="body-data col-1 grey"><p>Pier G ITS</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td></tr><tr><td class="body-data col-1"><p>Pier J SSA PCT</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td></tr><tr><td class="body-data col-1 grey"><p>Pier T TTI</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>Open</p></td><td class="body-data "><p>TBD</p></td><td class="body-data "><p>Open</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data closed"><p>Closed</p></td><td class="body-data "><p>TBD</p></td></tr></tbody>
            </table>
          </div> */}

          {
            tableData && tableData.length > 0 ?
              <React.Fragment>

                <div className="table-functions-container gutter">
                  <button type="button" className="pdf" onClick={this.pdfTable}>PDF</button>
                  <button type="button" className="excel" onClick={this.excelTable}>EXCEL</button>
                  {/* <ReactHTMLTableToExcel
                    id="table-xls-button"
                    className="download-table-xls-button"
                    table="bc-table-document"
                    filename="gate-hours-table"
                    sheet="tablexlsx"
                    buttonText="EXCEL"
                  /> */}
                  <button type="button" className="print" onClick={this.printTable}>PRINT</button>
                </div>

                <div className="bc-table-container gutter">

                  <div className="shadow-div"></div>
                  <table id="bc-table" className="bc-table files">


                    {/* MOBILE VERSION */}
                    <thead className="bc-table__header mobile">
                      <tr>
                        <th className="header-data"><p>Terminal</p></th>
                      </tr>
                    </thead>

                    <tbody className="bc-table__body mobile">
                      {
                        tableData && tableData.map((row, index) => {
                          let tableRow = [];
                          let shiftArray = [];

                          if (row.terminal.name === "Pier A SSA" || row.terminal.name === "Pier C SSA Matson" || row.terminal.name === "Pier E LBCT" || row.terminal.name === "Pier G ITS" || row.terminal.name === "Pier J SSA PCT" || row.terminal.name === "Pier T TTI") {
                            for (let i = 0; i < row.shifts.length; i++) {
                              let dateArray = row.shifts[i].local_date.split("-");
                              let formattedDate = `${dateArray[1]}/${dateArray[2]}/${dateArray[0].slice(-2)}`;
                              let formattedStatus = row.shifts[i].status === "To Be Ascertained" ? "TBD" : row.shifts[i].status;

                              let shiftList = (
                                <li className="list-item"><p><span>{`${formattedDate} ${row.shifts[i].description}`}</span> {formattedStatus}</p></li>
                              )

                              shiftArray.push(shiftList);
                            }

                            let rowSection = (
                              <tr key={index}>
                                <td className="body-data">
                                  <button type="button" onClick={this.expandRow} className="data-button" data-key={index}><span className="expand">+</span><span className="contract">-</span> <p>{row.terminal.name}</p></button>
                                  <ul className="data-list">
                                    {shiftArray}
                                  </ul>
                                </td>
                              </tr>
                            )

                            tableRow.push(rowSection);
                          }

                          return (
                            <React.Fragment>
                              {tableRow}
                            </React.Fragment>
                          )
                        })
                      }
                    </tbody>


                    {/* DESKTOP VERSION */}
                    <thead className="bc-table__header">
                      <tr>
                        <th className="header-data col-1"><p>Terminal</p></th>
                        {
                          tableData && tableData[0].shifts.map((row, index) => {
                            let dateArray = row.local_date.split("-");
                            let formattedDate = `${dateArray[1]}/${dateArray[2]}/${dateArray[0].slice(-2)}`;

                            return (
                              <th key={index} className="header-data">
                                <p>{formattedDate}</p>
                                <p>{row.description}</p>
                              </th>
                            )
                          })
                        }
                      </tr>
                    </thead>

                    <tbody className="bc-table__body">
                      {
                        tableData && tableData.map((row, index) => {
                          let tableRow = [];
                          let shiftArray = [];

                          if (row.terminal.name === "Pier A SSA" || row.terminal.name === "Pier C SSA Matson" || row.terminal.name === "Pier E LBCT" || row.terminal.name === "Pier G ITS" || row.terminal.name === "Pier J SSA PCT" || row.terminal.name === "Pier T TTI") {
                            for (let i = 0; i < row.shifts.length; i++) {
                              let closed = row.shifts[i].status === "Closed" ? true : false;
                              let formattedStatus = row.shifts[i].status === "To Be Ascertained" ? "TBD" : row.shifts[i].status;

                              let shift = (
                                <td className={`body-data ${closed ? "closed" : ""}`}><p>{formattedStatus}</p></td>
                              )

                              shiftArray.push(shift);
                            }

                            let rowSection = (
                              <tr key={index}>
                                <td className="body-data col-1"><p>{row.terminal.name}</p></td>
                                {shiftArray}
                              </tr>
                            )

                            tableRow.push(rowSection);
                          }

                          return (
                            <React.Fragment>
                              {tableRow}
                            </React.Fragment>
                          )
                        })
                      }
                    </tbody>
                  </table>





                  {/* EXCEL VERSION */}
                  <div id="bc-table-excel">
                    <table id="bc-table-document" style={printTableStyles}>
                      <thead className="bc-table__header">
                        <tr>
                          <th className="header-data" style={printHeaderStyles}><p style={printHeaderTextStyles}>Port of Long Beach – Gate Schedules | Data powered by Blue Cargo</p></th>
                        </tr>
                        <tr style={{ backgroundColor: "#ececec" }}>
                          <th className="header-data" style={printHeaderStyles}><p style={printHeaderTextStyles}>Terminal</p></th>
                          {
                            tableData && tableData[0].shifts.map((row, index) => {
                              let dateArray = row.local_date.split("-");
                              let formattedDate = `${dateArray[1]}/${dateArray[2]}/${dateArray[0].slice(-2)} ${row.description}`;

                              return (
                                <th key={index} className="header-data" style={printHeaderStyles}>
                                  <p style={printHeaderTextStyles}>{formattedDate}</p>
                                </th>
                              )
                            })
                          }
                        </tr>
                      </thead>

                      <tbody className="bc-table__body">
                        {
                          tableData && tableData.map((row, index) => {
                            let shiftArray = [];

                            if (row.terminal.name === "Pier A SSA" || row.terminal.name === "Pier C SSA Matson" || row.terminal.name === "Pier E LBCT" || row.terminal.name === "Pier G ITS" || row.terminal.name === "Pier J SSA PCT" || row.terminal.name === "Pier T TTI") {
                              for (let i = 0; i < row.shifts.length; i++) {
                                let formattedStatus = row.shifts[i].status === "To Be Ascertained" ? "TBD" : row.shifts[i].status;
                                let shift;

                                if (formattedStatus === "Closed") {
                                  shift = (
                                    <td className="body-data" style={printBodyStylesTwo}><p>{formattedStatus}</p></td>
                                  )
                                } else {
                                  shift = (
                                    <td className="body-data" style={printBodyStyles}><p>{formattedStatus}</p></td>
                                  )
                                }

                                shiftArray.push(shift);
                              }
                            }

                            return (
                              <React.Fragment>
                                {
                                  row.terminal.name === "Pier A SSA" || row.terminal.name === "Pier C SSA Matson" || row.terminal.name === "Pier E LBCT" || row.terminal.name === "Pier G ITS" || row.terminal.name === "Pier J SSA PCT" || row.terminal.name === "Pier T TTI" ?
                                    <tr key={index}>
                                      <td className="body-data" style={printBodyTextBold}><p>{row.terminal.name}</p></td>
                                      {shiftArray}
                                    </tr>
                                    :
                                    null
                                }
                              </React.Fragment>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </div>

                  {/* PDF/PRINT VERSION */}
                  <div id="bc-table-print">
                    <div style={headerContainer}>
                      <img src={logo2} alt="Port of Long Beach logo" className="header__logo-2" style={{ "height": "50px", "transform": "translateY(5px)" }} />
                      <h2>Gate Schedules</h2>
                      <div style={bcTextContainer}>
                        <h2 style={bcText}>Data powered by BlueCargo</h2>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 151 130" style={bcLogo}>
                          <path d="M107.77 14.043C109.847 12.842 108.529 10.019 115.224 10C119.927 9.98803 121.848 13.93 121.92 18.466C122.047 26.424 120.473 23.941 116.866 25.299C113.202 26.677 116.639 32.346 117.625 34.062C121.641 41.061 119.898 31.478 121.792 29.961C123.688 28.445 129.588 29.263 133.63 34.822C136.446 38.693 135.211 50.043 136.955 66.095C138.125 76.886 129.121 68.309 121.16 53.459C119.02 49.466 110.71 33.454 110.928 26.172C111.054 21.961 116.109 23.257 116.992 19.856C117.947 16.184 112.058 16.239 110.928 16.193C107.896 16.066 103.08 17.736 96.2622 19.102C94.1522 19.525 105.401 15.418 107.77 14.043Z" stroke="#DA8042" strokeWidth="2" strokeMiterlimit="10" />
                          <rect x="124.8" y="61.11" width="2" height="31" rx="1" fill="#DA7E3F" />
                          <path d="M27.08 56.36C28.9467 56.7067 30.4533 57.3867 31.6 58.4C32.7733 59.3867 33.36 60.9067 33.36 62.96C33.36 65.8667 32.32 67.9333 30.24 69.16C28.16 70.3867 25.2667 71 21.56 71H12.92V43.32H20.48C24.2667 43.32 27.16 43.88 29.16 45C31.16 46.12 32.16 47.92 32.16 50.4C32.16 52.0267 31.6667 53.3467 30.68 54.36C29.72 55.3467 28.52 56.0133 27.08 56.36ZM18.8 47.56V54.56H21.68C23.12 54.56 24.2267 54.2667 25 53.68C25.7733 53.0667 26.16 52.1467 26.16 50.92C26.16 49.6933 25.7467 48.8267 24.92 48.32C24.0933 47.8133 22.8 47.56 21.04 47.56H18.8ZM21.6 66.64C23.44 66.64 24.84 66.3733 25.8 65.84C26.76 65.28 27.24 64.24 27.24 62.72C27.24 59.9467 25.5333 58.56 22.12 58.56H18.8V66.64H21.6ZM45.0094 43.32V66.28H55.9694L55.3294 71H39.1294V43.32H45.0094ZM80.7453 61.88C80.7453 63.7733 80.3453 65.4533 79.5453 66.92C78.7453 68.3867 77.5453 69.5467 75.9453 70.4C74.372 71.2267 72.452 71.64 70.1853 71.64C66.772 71.64 64.1586 70.76 62.3453 69C60.5586 67.2133 59.6653 64.84 59.6653 61.88V43.32H65.5453V61.6C65.5453 63.4667 65.9186 64.8667 66.6653 65.8C67.412 66.7067 68.5853 67.16 70.1853 67.16C71.7853 67.16 72.9586 66.7067 73.7053 65.8C74.4786 64.8667 74.8653 63.4667 74.8653 61.6V43.32H80.7453V61.88ZM104.357 43.32L103.717 47.6H93.7172V54.8H102.437V59.04H93.7172V66.68H104.437V71H87.8372V43.32H104.357Z" fill="#17294D" />
                          <path d="M23.84 80.68C25.5733 80.68 27.08 80.9333 28.36 81.44C29.64 81.92 30.8933 82.6667 32.12 83.68L29.2 87.08C27.6 85.7733 25.92 85.12 24.16 85.12C22.1867 85.12 20.6133 85.9333 19.44 87.56C18.2933 89.16 17.72 91.68 17.72 95.12C17.72 98.48 18.2933 100.973 19.44 102.6C20.6133 104.2 22.2 105 24.2 105C25.24 105 26.1867 104.813 27.04 104.44C27.8933 104.04 28.7867 103.48 29.72 102.76L32.44 106.16C31.4533 107.173 30.2267 108.013 28.76 108.68C27.32 109.32 25.72 109.64 23.96 109.64C21.48 109.64 19.3067 109.08 17.44 107.96C15.5733 106.84 14.12 105.2 13.08 103.04C12.04 100.853 11.52 98.2133 11.52 95.12C11.52 92.1067 12.0533 89.52 13.12 87.36C14.1867 85.1733 15.6533 83.52 17.52 82.4C19.3867 81.2533 21.4933 80.68 23.84 80.68ZM52.0116 109L50.4516 102.8H41.7716L40.2116 109H34.0916L42.6116 81.32H49.7716L58.2516 109H52.0116ZM42.8916 98.44H49.3316L46.0916 85.68L42.8916 98.44ZM71.2891 98.16H68.2891V109H62.4091V81.32H71.0491C74.7557 81.32 77.5424 82.0133 79.4091 83.4C81.2757 84.76 82.2091 86.8267 82.2091 89.6C82.2091 91.4133 81.7557 92.9067 80.8491 94.08C79.9691 95.2533 78.5957 96.2533 76.7291 97.08L83.8891 109H77.2091L71.2891 98.16ZM68.2891 94H71.3691C72.9424 94 74.1291 93.6533 74.9291 92.96C75.7291 92.24 76.1291 91.12 76.1291 89.6C76.1291 88.1867 75.7024 87.16 74.8491 86.52C74.0224 85.8533 72.7157 85.52 70.9291 85.52H68.2891V94ZM99.6706 80.68C101.537 80.68 103.191 80.9733 104.631 81.56C106.097 82.12 107.457 82.9333 108.711 84L105.631 87.2C104.644 86.4533 103.711 85.9067 102.831 85.56C101.977 85.2133 101.004 85.04 99.9106 85.04C97.804 85.04 96.0973 85.88 94.7906 87.56C93.5106 89.2133 92.8706 91.7467 92.8706 95.16C92.8706 98.76 93.364 101.347 94.3506 102.92C95.364 104.467 96.924 105.24 99.0306 105.24C100.551 105.24 101.924 104.907 103.151 104.24V97.48H99.2706L98.6706 93.2H108.871V106.84C107.431 107.72 105.871 108.413 104.191 108.92C102.537 109.4 100.857 109.64 99.1506 109.64C95.0706 109.64 91.9773 108.413 89.8706 105.96C87.764 103.507 86.7106 99.8933 86.7106 95.12C86.7106 92.1067 87.284 89.5067 88.4306 87.32C89.5773 85.1333 91.124 83.48 93.0706 82.36C95.044 81.24 97.244 80.68 99.6706 80.68ZM126.256 80.68C128.789 80.68 130.976 81.2533 132.816 82.4C134.656 83.52 136.069 85.16 137.056 87.32C138.042 89.48 138.536 92.0933 138.536 95.16C138.536 98.1733 138.042 100.773 137.056 102.96C136.069 105.12 134.656 106.773 132.816 107.92C130.976 109.067 128.789 109.64 126.256 109.64C123.722 109.64 121.522 109.08 119.656 107.96C117.816 106.813 116.402 105.16 115.416 103C114.429 100.813 113.936 98.2 113.936 95.16C113.936 92.1733 114.429 89.6 115.416 87.44C116.429 85.2533 117.856 83.5867 119.696 82.44C121.562 81.2667 123.749 80.68 126.256 80.68ZM126.256 85.08C124.229 85.08 122.696 85.88 121.656 87.48C120.642 89.08 120.136 91.64 120.136 95.16C120.136 98.68 120.656 101.24 121.696 102.84C122.736 104.44 124.256 105.24 126.256 105.24C128.282 105.24 129.802 104.453 130.816 102.88C131.829 101.28 132.336 98.7067 132.336 95.16C132.336 91.6133 131.829 89.0533 130.816 87.48C129.802 85.88 128.282 85.08 126.256 85.08Z" fill="#17294D" />
                        </svg>
                      </div>
                    </div>
                    <table id="bc-table-pdf-1" style={printTableStyles}>
                      <thead className="bc-table__header">
                        <tr style={{ backgroundColor: "#ececec" }}>
                          <th className="header-data" style={printHeaderStyles}><p style={printHeaderTextStyles}>Terminal</p></th>
                          {
                            tableData && tableData[0].shifts.map((row, index) => {
                              if (index < 14) {
                                let dateArray = row.local_date.split("-");
                                let formattedDate = `${dateArray[1]}/${dateArray[2]}/${dateArray[0].slice(-2)}`;

                                return (
                                  <th key={index} className="header-data" style={printHeaderStyles}>
                                    <p style={printHeaderTextStyles}>{formattedDate}</p>
                                    <p style={printHeaderTextStyles}>{row.description}</p>
                                  </th>
                                )
                              }
                            })
                          }
                        </tr>
                      </thead>

                      <tbody className="bc-table__body">
                        {
                          tableData && tableData.map((row, index) => {
                            let shiftArray = [];

                            if (row.terminal.name === "Pier A SSA" || row.terminal.name === "Pier C SSA Matson" || row.terminal.name === "Pier E LBCT" || row.terminal.name === "Pier G ITS" || row.terminal.name === "Pier J SSA PCT" || row.terminal.name === "Pier T TTI") {
                              for (let i = 0; i < row.shifts.length; i++) {
                                if (i < 14) {
                                  let formattedStatus = row.shifts[i].status === "To Be Ascertained" ? "TBD" : row.shifts[i].status;
                                  let shift;

                                  if (formattedStatus === "Closed") {
                                    shift = (
                                      <td className="body-data" style={printBodyStylesTwo}><p>{formattedStatus}</p></td>
                                    )
                                  } else {
                                    shift = (
                                      <td className="body-data" style={printBodyStyles}><p>{formattedStatus}</p></td>
                                    )
                                  }

                                  shiftArray.push(shift);
                                }
                              }
                            }

                            return (
                              <React.Fragment>
                                {
                                  row.terminal.name === "Pier A SSA" || row.terminal.name === "Pier C SSA Matson" || row.terminal.name === "Pier E LBCT" || row.terminal.name === "Pier G ITS" || row.terminal.name === "Pier J SSA PCT" || row.terminal.name === "Pier T TTI" ?
                                    <tr key={index}>
                                      <td className="body-data" style={printBodyTextBold}><p>{row.terminal.name}</p></td>
                                      {shiftArray}
                                    </tr>
                                    :
                                    null
                                }
                              </React.Fragment>
                            )
                          })
                        }
                      </tbody>
                    </table>

                    <table id="bc-table-pdf-2" style={printTableStylesTwo}>
                      <thead className="bc-table__header">
                        <tr style={{ backgroundColor: "#ececec" }}>
                          <th className="header-data" style={printHeaderStyles}><p style={printHeaderTextStyles}>Terminal</p></th>
                          {
                            tableData && tableData[0].shifts.map((row, index) => {
                              if (index >= 14 && index < 28) {
                                let dateArray = row.local_date.split("-");
                                let formattedDate = `${dateArray[1]}/${dateArray[2]}/${dateArray[0].slice(-2)}`;

                                return (
                                  <th key={index} className="header-data" style={printHeaderStyles}>
                                    <p style={printHeaderTextStyles}>{formattedDate}</p>
                                    <p style={printHeaderTextStyles}>{row.description}</p>
                                  </th>
                                )
                              }
                            })
                          }
                        </tr>
                      </thead>

                      <tbody className="bc-table__body">
                        {
                          tableData && tableData.map((row, index) => {
                            let shiftArray = [];

                            if (row.terminal.name === "Pier A SSA" || row.terminal.name === "Pier C SSA Matson" || row.terminal.name === "Pier E LBCT" || row.terminal.name === "Pier G ITS" || row.terminal.name === "Pier J SSA PCT" || row.terminal.name === "Pier T TTI") {
                              for (let i = 0; i < row.shifts.length; i++) {
                                if (i >= 14 && i < 28) {
                                  let formattedStatus = row.shifts[i].status === "To Be Ascertained" ? "TBD" : row.shifts[i].status;
                                  let shift;

                                  if (formattedStatus === "Closed") {
                                    shift = (
                                      <td className="body-data" style={printBodyStylesTwo}><p>{formattedStatus}</p></td>
                                    )
                                  } else {
                                    shift = (
                                      <td className="body-data" style={printBodyStyles}><p>{formattedStatus}</p></td>
                                    )
                                  }

                                  shiftArray.push(shift);
                                }
                              }
                            }

                            return (
                              <React.Fragment>
                                {
                                  row.terminal.name === "Pier A SSA" || row.terminal.name === "Pier C SSA Matson" || row.terminal.name === "Pier E LBCT" || row.terminal.name === "Pier G ITS" || row.terminal.name === "Pier J SSA PCT" || row.terminal.name === "Pier T TTI" ?
                                    <tr key={index}>
                                      <td className="body-data" style={printBodyTextBold}><p>{row.terminal.name}</p></td>
                                      {shiftArray}
                                    </tr>
                                    :
                                    null
                                }
                              </React.Fragment>
                            )
                          })
                        }
                      </tbody>
                    </table>

                    <table id="bc-table-pdf-3" style={printTableStylesTwo}>
                      <thead className="bc-table__header">
                        <tr style={{ backgroundColor: "#ececec" }}>
                          <th className="header-data" style={printHeaderStyles}><p style={printHeaderTextStyles}>Terminal</p></th>
                          {
                            tableData && tableData[0].shifts.map((row, index) => {
                              if (index >= 28) {
                                let dateArray = row.local_date.split("-");
                                let formattedDate = `${dateArray[1]}/${dateArray[2]}/${dateArray[0].slice(-2)}`;

                                return (
                                  <th key={index} className="header-data" style={printHeaderStyles}>
                                    <p style={printHeaderTextStyles}>{formattedDate}</p>
                                    <p style={printHeaderTextStyles}>{row.description}</p>
                                  </th>
                                )
                              }
                            })
                          }
                        </tr>
                      </thead>

                      <tbody className="bc-table__body">
                        {
                          tableData && tableData.map((row, index) => {
                            let shiftArray = [];

                            if (row.terminal.name === "Pier A SSA" || row.terminal.name === "Pier C SSA Matson" || row.terminal.name === "Pier E LBCT" || row.terminal.name === "Pier G ITS" || row.terminal.name === "Pier J SSA PCT" || row.terminal.name === "Pier T TTI") {
                              for (let i = 0; i < row.shifts.length; i++) {
                                if (i >= 28) {
                                  let formattedStatus = row.shifts[i].status === "To Be Ascertained" ? "TBD" : row.shifts[i].status;
                                  let shift;

                                  if (formattedStatus === "Closed") {
                                    shift = (
                                      <td className="body-data" style={printBodyStylesTwo}><p>{formattedStatus}</p></td>
                                    )
                                  } else {
                                    shift = (
                                      <td className="body-data" style={printBodyStyles}><p>{formattedStatus}</p></td>
                                    )
                                  }

                                  shiftArray.push(shift);
                                }
                              }
                            }

                            return (
                              <React.Fragment>
                                {
                                  row.terminal.name === "Pier A SSA" || row.terminal.name === "Pier C SSA Matson" || row.terminal.name === "Pier E LBCT" || row.terminal.name === "Pier G ITS" || row.terminal.name === "Pier J SSA PCT" || row.terminal.name === "Pier T TTI" ?
                                    <tr key={index}>
                                      <td className="body-data" style={printBodyTextBold}><p>{row.terminal.name}</p></td>
                                      {shiftArray}
                                    </tr>
                                    :
                                    null
                                }
                              </React.Fragment>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </React.Fragment>
              :
              null
          }
        </Layout>
      </React.Fragment>
    );
  }
}

export default BlueCargo;

